module.exports = __webpack_public_path__ + "media/images/flags/64/Oman-991fcea46eb702cb5c79dfd7bf1be79e.png";